import type { ComponentType } from "react"
import { withViewData } from "../../../App/ViewData"
import type { AppViewProps } from "../Params"
import { SelectedShipDataView } from "./DataView"

export function withSelectedShipData(UI: ComponentType<AppViewProps>): ComponentType<AppViewProps> {
  return withViewData<AppViewProps>({
    acquire: SelectedShipDataView,
    ui: UI,
  });
}

export { useSelectedShip } from "./Context"
